<div class="flex-row margin-tb-10">
  <div class="flex-1"></div>

  <mat-accordion class="headers-align flex-3" multi>
    <mat-expansion-panel [expanded]="true">
      @if (loadingServiceApplication) {
        <mat-progress-bar style="height: 5px;" mode="indeterminate"></mat-progress-bar>
      }

      <mat-expansion-panel-header>
        <mat-panel-title>
          Demographics
        </mat-panel-title>
        <mat-panel-description>
          <span class="{{getDemographicReviewStatus}}">{{getDemographicReviewStatus}}</span>
          <mat-icon>person</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <hr>

        @if (!loadingServiceApplication) {
          <div class="margin-lr-20">
            <h2>
              {{serviceApplication?.serviceProviderDemographicModel?.name}}
            </h2>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Email</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.emailAddress}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Address</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.address}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">City</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.city}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">State</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.state}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Zip Code</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.zipCode}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Primary Phone Number</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.primaryPhoneNumber}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Secondary Phone Number</div>
              <div class="flex-3">{{serviceApplication?.serviceProviderDemographicModel?.secondaryPhoneNumber}}</div>
            </div>
          </div>
        }

        <div class="padding-20 flex-row float-right">
          <mat-checkbox class="margin-lr-10" [(ngModel)]="demographicsValid">Are these demographics acceptable?</mat-checkbox>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Files
          </mat-panel-title>
          <mat-panel-description>
            <span class="{{getFilesReviewStatus}}">{{getFilesReviewStatus}}</span>
            <mat-icon>attach_file</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <hr>

          <div class="flex-row margin-lr-20">
            <div class="flex-1">
              <h2>{{serviceApplication?.serviceProviderDemographicModel?.name}}'s Files</h2>

              @for (serviceDocument  of serviceApplication?.serviceDocumentModels; track serviceDocument ) {
                <div class="flex-row align-items-center">
                  <button mat-icon-button
                    aria-label="Download this document"
                    matTooltip="Download file"
                    (click)="downloadFile(serviceDocument)">
                    <mat-icon>file_download</mat-icon>
                  </button>
                  {{serviceDocument?.name}}
                </div>
              }
            </div>
          </div>

          <div class="padding-20 flex-row float-right">
            <mat-checkbox class="margin-lr-10" [(ngModel)]="filesValid">Are the files valid?</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Service Plan
            </mat-panel-title>
            <mat-panel-description>
              <span class="{{getServicePlansReviewStatus}}">{{getServicePlansReviewStatus}}</span>
              <mat-icon>attach_money</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <hr>

            <div class="margin-lr-20">
              @for (applicationServicePlan of serviceApplication?.serviceApplicationServicePlanModels; track applicationServicePlan; let j = $index) {
                <div>
                  <h2>Service Plan {{j+1}}</h2>
                  <div class="flex-row padding-5 max-width-600">
                    <div class="flex-1 bold-text">Provider</div>
                    <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.name}}</div>
                  </div>
                  <div class="flex-row padding-5 max-width-600">
                    <div class="flex-1 bold-text">Provider Location</div>
                    <div class="flex-1">
                      {{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.address}}<br>
                      {{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.city}}
                      {{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.state}}<br>
                      {{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.zipCode}}
                    </div>
                  </div>
                  <div class="flex-row padding-5 max-width-600">
                    <div class="flex-1 bold-text">Provider Phone Number</div>
                    <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.serviceProviderModel?.primaryPhoneNumber}}</div>
                  </div>
                  <div class="flex-row padding-5 max-width-600">
                    <div class="flex-1 bold-text">Service Type</div>
                    <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.serviceTypeModel?.name}}</div>
                  </div>
                  @if (applicationServicePlan?.servicePlanModel?.description != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Description</div>
                      <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.description}}</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.rate != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Rate</div>
                      <div class="flex-1">${{applicationServicePlan?.servicePlanModel?.rate}}</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.rateType != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Rate Type</div>
                      <div class="flex-1">${{applicationServicePlan?.servicePlanModel?.rateType}}</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.discountCap != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Discount Cap</div>
                      <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.discountCap}} %</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.discountCapQuantity != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Discount Quantity</div>
                      <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.discountCapQuantity}} discounts</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.volunteerDiscountCap != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Volunteer Discount Cap</div>
                      <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.volunteerDiscountCap}} %</div>
                    </div>
                  }
                  @if (applicationServicePlan?.servicePlanModel?.volunteerDiscountCapQuantity != null ) {
                    <div class="flex-row padding-5 max-width-600">
                      <div class="flex-1 bold-text">Volunteer Discount Quantity</div>
                      <div class="flex-1">{{applicationServicePlan?.servicePlanModel?.volunteerDiscountCapQuantity}} discounts</div>
                    </div>
                  }
                  <hr>
                  </div>
                }
              </div>

              <div class="padding-20 flex-row float-right">
                <mat-checkbox class="margin-lr-10" [(ngModel)]="servicePlansValid">Are the selected service plans valid?</mat-checkbox>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Notes
                </mat-panel-title>
                <mat-panel-description>
                  <span></span>
                  <mat-icon>comment_outline</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <hr>

                <div class="text-box-width flex-row">
                  <mat-form-field class="flex-3">
                    <mat-label>Leave a note</mat-label>
                    <textarea matInput placeholder="This needs work because..." [(ngModel)]="note"></textarea>
                  </mat-form-field>

                  <div class="flex-1 margin-20">
                    <button mat-stroked-button
                      color="primary"
                      aria-label="Save comment"
                      (click)="postNote()">
                      Save
                    </button>
                  </div>
                </div>

                @if (loadingNotes) {
                  <mat-progress-bar style="height: 4px;" mode="indeterminate"></mat-progress-bar>
                }

                <div class="scrollable-table">
                  <table mat-table [dataSource]="applicationNoteDataSource" class="mat-elevation-z8">
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef class="padding-5">Note</th>
                      <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element.note}}</td>
                    </ng-container>

                    <ng-container matColumnDef="employee">
                      <th mat-header-cell *matHeaderCellDef class="padding-5">Employee</th>
                      <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element.employeeModel.emailAddress}}</td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef class="padding-5">Date</th>
                      <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element.createDateUTC | date:'medium'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button
                          (click)="deleteNote(element.applicationNoteId)"
                          matTooltip="Delete note"
                          class="span-form margin-tb-10">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="applicationNoteColumnHeaders"></tr>
                    <tr mat-row *matRowDef="let row; columns: applicationNoteColumnHeaders;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="4">No notes found.</td>
                    </tr>
                  </table>
                </div>
              </mat-expansion-panel>

              <div class="margin-tb-10 margin-top-30">
                @if (saving) {
                  <mat-progress-bar style="height: 5px;" mode="indeterminate"></mat-progress-bar>
                }
              </div>

              <div class="margin-tb-10 margin-top-30">
                @if (!saving) {
                  <button
                    mat-raised-button
                    color="primary"
                    class="button-full-width margin-top-30"
                    (click)="onNeedsWorkServiceApplication()">
                    Needs Work
                  </button>
                }
              </div>

              <div class="margin-tb-10">
                @if (!saving) {
                  <button
                    mat-raised-button
                    color="primary"
                    class="button-full-width margin-top-30"
                    (click)="onDenyServiceApplication()">
                    Deny
                  </button>
                }
              </div>

              <div class="button-full-width">
                @if (!saving) {
                  <button
                    [disabled]="!demographicsValid || !filesValid || !servicePlansValid"
                    mat-raised-button
                    color="primary"
                    class="button-full-width"
                    (click)="onApproveServiceApplication()">
                    Approve
                  </button>
                }
              </div>
            </mat-accordion>

            <div class="flex-1 padding-30">
              <button mat-icon-button
                matTooltip="Return to service applications"
                (click)="goBack()"
                class="float-right"
                aria-label="Return to service applications">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>
          </div>